// extracted by mini-css-extract-plugin
module.exports = {"LoadingSpinnerContainer":"LoadingSpinner_LoadingSpinnerContainer__MWzSl"};